import { Link } from "react-router-dom";
import { BrandLockup } from "@/shell/CandidateFlow";

const sections = [
  {
    title: "1. Who we are",
    body: "Executive Interview Coach (executiveinterview.coach) is run by Andrew Akuffo, a sole trader in England. Contact: privacy@executiveinterview.coach. For beta sign-ups, recruiter accounts and technical logs, we are the data controller. For candidate data, the recruiting firm that invited the candidate is the controller, and we process that data on its behalf as its processor, under its instructions. Candidates can contact their recruiting firm or us to exercise their rights.",
  },
  {
    title: "2. Data we collect",
    body: "Beta sign-ups: name, firm name and email address. Recruiter accounts: name, firm, email address and branding details. Candidate data, when a firm invites a candidate: name, email address, CV, job description, interview transcripts (text of what was said), AI-generated scorecards and preparation notes. We do not store audio recordings of interviews. Usage data: technical logs (IP address, user agent, timestamps) for security.",
  },
  {
    title: "3. Legal basis (UK GDPR)",
    body: "Beta sign-ups and recruiter accounts: legitimate interests and performance of our contract with the firm. Candidate coaching sessions: processed for the recruiting firm, which sets its own legal basis as controller. Technical logs: legitimate interests (security and fraud prevention).",
  },
  {
    title: "4. How we use your data, and AI feedback",
    body: "We use personal data only to provide and secure the service. We do not sell personal data or use it for advertising. Scores and feedback are generated by AI as practice feedback. They are not a hiring decision and are not used to make decisions with legal or similarly significant effects about you. You can ask for a human review of any score through your consultant or privacy@executiveinterview.coach.",
  },
  {
    title: "5. Service providers (sub-processors)",
    body: "Google (Gemini AI for interviews, scoring and notes), OpenAI (text-to-speech narration), Fly.io (hosting, London region), Resend (transactional email), Sentry (error monitoring), Discord (internal error alerts), and ForwardEmail (receives mail sent to our privacy, legal and hello addresses). If switched on for your firm: Stripe (billing) and LinkedIn (sign-in). Each provider processes data only to deliver its part of the service.",
  },
  {
    title: "6. Retention",
    body: "Candidate data: deleted after 12 months with no activity, or earlier on request or when the recruiting firm erases it. Beta sign-ups: deleted after 12 months. Audit logs: 90 days. Our hosting keeps daily disk backups for 5 days, so erased data leaves the backups within 5 days of erasure.",
  },
  {
    title: "7. Your rights",
    body: "Under UK GDPR you have the right to access, rectify, erase, restrict or port your personal data, and to object to processing. Candidates can erase their data from the portal and, once their email is verified, download a copy of it from Settings. For anything else, contact privacy@executiveinterview.coach. You also have the right to complain to the ICO (ico.org.uk).",
  },
  {
    title: "8. International transfers",
    body: "Our servers are in the UK (Fly.io, London). Some providers process data outside the UK, mainly in the United States. For those transfers we rely on UK adequacy regulations, including the UK Extension to the EU-US Data Privacy Framework where the provider is certified, or the UK International Data Transfer Agreement or the UK Addendum to the EU Standard Contractual Clauses.",
  },
  {
    title: "9. Cookies",
    body: "We use a single session cookie (httpOnly, Secure, SameSite=Lax) for authentication. We do not use advertising or tracking cookies.",
  },
  {
    title: "10. Changes",
    body: "We will tell registered users about material changes to this policy, and candidates are asked to confirm the current version before their session. The current version is always available at executiveinterview.coach/privacy.",
  },
];

export function Privacy() {
  return (
    <div style={{ background: "#FBFAFE", minHeight: "100vh", fontFamily: "'Inter', system-ui, sans-serif" }}>
      <header style={{ borderBottom: "1px solid #EFEBF7", padding: "20px 40px", display: "flex", alignItems: "center", gap: 10 }}>
        <Link to="/" style={{ textDecoration: "none" }}>
          <BrandLockup />
        </Link>
      </header>
      <main style={{ maxWidth: 680, margin: "0 auto", padding: "60px 24px 80px" }}>
        <div style={{ fontFamily: "ui-monospace, monospace", fontSize: 10, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase" as const, color: "#7A6BE0", marginBottom: 16 }}>
          Legal
        </div>
        <h1 style={{ fontSize: 32, fontWeight: 700, color: "#17131F", marginBottom: 8, letterSpacing: "-0.02em" }}>Privacy Policy</h1>
        <p style={{ fontSize: 13, color: "#7C7590", marginBottom: 48 }}>Last updated: 2 October 2026 · Governing jurisdiction: England and Wales (UK GDPR)</p>
        {sections.map(({ title, body }) => (
          <section key={title} style={{ marginBottom: 36 }}>
            <h2 style={{ fontSize: 16, fontWeight: 600, color: "#17131F", marginBottom: 10 }}>{title}</h2>
            <p style={{ fontSize: 15, lineHeight: 1.7, color: "#4A4260" }}>{body}</p>
          </section>
        ))}
      </main>
      <footer style={{ borderTop: "1px solid #EFEBF7", padding: "20px 40px", display: "flex", gap: 20 }}>
        <Link to="/" style={{ fontFamily: "ui-monospace, monospace", fontSize: 10, color: "#7C7590", textDecoration: "none", letterSpacing: "0.06em" }}>Home</Link>
        <Link to="/terms" style={{ fontFamily: "ui-monospace, monospace", fontSize: 10, color: "#7C7590", textDecoration: "none", letterSpacing: "0.06em" }}>Terms of Service</Link>
      </footer>
    </div>
  );
}
